/**
 * Quem ve o que no lancamento, e quem ja viu.
 *
 * Funcoes puras — a decisao mora aqui para poder ser testada sem montar tela.
 */

/**
 * Data do lancamento. Conta criada ANTES disso ja usava o Metria e merece a
 * apresentacao das mudancas; criada depois ja nasce com tudo, e so precisa
 * saber que existe app.
 *
 * Fica em UTC de propósito: `tenant.created_at` vem do banco em UTC, e comparar
 * com data local faria a fronteira andar tres horas — quem cadastrou na noite
 * da vespera cairia do lado errado.
 */
export const LANCAMENTO = '2026-09-01T15:00:00Z';   // 01/09 ao meio-dia em BRT (UTC-3)

/** Chave versionada: o proximo anuncio troca a versao e reaparece para todos. */
export const CHAVE_VISTO = 'novidades_vistas:2026-09-01';

/**
 * @returns {'mudancas'|'app'|null}
 *   'mudancas' — ja usava o Metria: apresentacao do que mudou
 *   'app'      — conta nova: so o convite para o app
 *   null       — nao mostrar nada
 */
export function oQueMostrar({ tenantCriadoEm, jaViu = false, dentroDoApp = false, agora = null } = {}) {
  // ANTES DA DATA, NADA. O codigo do anuncio sobe para producao dias antes do
  // lancamento, e sem esta trava ele comeca a aparecer no instante do deploy —
  // aconteceu em 31/08/2026. E nao e so "cedo demais": quem fecha antes da hora
  // nao ve de novo no dia certo, porque o "ja viu" fica no navegador. O anuncio
  // se gasta sozinho, para as pessoas erradas.
  const hoje = agora || new Date();
  if (hoje < new Date(LANCAMENTO)) return null;

  if (jaViu) return null;
  // Dentro do app o convite nao faz sentido, e as mudancas ela ja esta vendo.
  if (dentroDoApp) return null;
  if (!tenantCriadoEm) return null;

  const criado = new Date(tenantCriadoEm);
  if (Number.isNaN(criado.getTime())) return null;
  return criado < new Date(LANCAMENTO) ? 'mudancas' : 'app';
}

/** Marca como visto. Falha em silencio: perder isso mostra o aviso de novo, e
 *  mostrar de novo e melhor que quebrar a tela de quem bloqueia storage. */
export function marcarVisto(storage) {
  try {
    (storage || window.localStorage).setItem(CHAVE_VISTO, 'true');
  } catch { /* modo privado, storage cheio: segue */ }
}

export function jaViu(storage) {
  try {
    return (storage || window.localStorage).getItem(CHAVE_VISTO) === 'true';
  } catch {
    return false;
  }
}
